import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../../lib/site";

export const WhatsAppFloat = () => {
  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp com a Dra. Luz Adriana"
      className="fixed bottom-6 right-6 z-50 wa-pulse bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-4 shadow-2xl transition-transform hover:-translate-y-1 grid place-items-center"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2} />
    </a>
  );
};
